<!--<div class="home-particle particle-2"></div>
<div class="home-particle particle-3"></div>
<div class="home-particle particle-4"></div>
<img
    src="/assets/images/v2/jackpot/header-coins.svg" height="50" alt="" class="jackpot-amount-img">-->

<div class="jackpot-win-amount-label-wrap">
    <div>WIN&nbsp;THE</div>
    <div class="jackpot-win-amount-label">JACKPOT</div>
</div>
<div class="jackopot-win-amount-wrap">
    <div class="jackpot-timer-label-wrap">
        <div>{{ ends.days }}d : {{ ends.hours }}hr : {{ ends.minutes }}m</div>
    </div>
    <div *ngFor="let val of jackpotValue" [class.jackpot-win-amount-number]="isNumber(val)">
        {{ val }}
    </div>
</div>


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/header-navigation/jackpot-header-new/jackpot-header.template.html